import "./LiveClassroomStream.css"
import {Maximize} from "lucide-react"

export default function LiveClassroomStream() {
  return (
    <div className="live-stream-container">
      <div className="live-stream-video-container">
        <img
          src="https://placehold.co/600x400"
          alt="Sala de aula 428"
          className="live-stream-image"
        />

        <div className="live-stream-overlay-gradient"></div>

        <div className="live-stream-camera-name">
          <h2>Câmera - Sala 428</h2>
        </div>

        <button className="live-stream-fullscreen-button" aria-label="Tela cheia">
          <Maximize />
        </button>

        <div className="live-stream-transmission">
          <div className="live-stream-indicator"></div>
          <span>Transmissão ao vivo</span>
        </div>

        <div className="live-stream-badge">
          <div>
            <span>AO VIVO</span>
          </div>
        </div>
      </div>
    </div>
  )
}
